import PinchZoom from 'pinch-zoom-element';

const clampNumber = (num, min, max) => Math.min(Math.max(num, min), max);

const init = function() {
  const component = document.querySelector(".product-fullscreen-zoom");
  if (!component) return;

  const buttonsZoom = component.querySelectorAll('.product-zoom-button');
  const currentValue = component.querySelector('.product-zoom-current');
  const zoomImage = document.querySelector('.product-fullscreen-image');
  const zoomStep = 50;
  const minScale = 100;
  const maxScale = 200;
  let currentPercentage = 100;
  let referenceScale = 1;
  const pinchZoom = document.querySelector('.product-fullscreen-pinchable-image');
  const minusButton = component.querySelector('[data-zoom="minus"]');

  // Prevent all dragging by overriding touch and mouse events
  if (pinchZoom) {
    // Disable touch actions
    pinchZoom.style.touchAction = 'none';
    
    // Prevent all touch events
    const preventDefault = (e) => {
      if (e.touches.length > 1) {
        // Allow pinch zoom but prevent panning
        e.preventDefault();
      } else {
        // Prevent single finger dragging completely
        e.preventDefault();
      }
    };
    
    pinchZoom.addEventListener('touchstart', preventDefault, { passive: false });
    pinchZoom.addEventListener('touchmove', preventDefault, { passive: false });
    
    // Prevent mouse dragging
    let isMouseDown = false;
    pinchZoom.addEventListener('mousedown', (e) => {
      isMouseDown = true;
      e.preventDefault();
    });
    
    document.addEventListener('mousemove', (e) => {
      if (isMouseDown) e.preventDefault();
    });
    
    document.addEventListener('mouseup', () => {
      isMouseDown = false;
    });
    
    // Override setTransform to always center the image
    const originalSetTransform = pinchZoom.setTransform;
    pinchZoom.setTransform = function(options) {
      // Always center the image regardless of input
      options.x = (window.innerWidth / 2) - ((zoomImage.clientWidth / 2) * options.scale);
      options.y = (window.innerHeight / 2) - ((zoomImage.clientHeight / 2) * options.scale);
      originalSetTransform.call(pinchZoom, options);
    };
  }

  function setTransform(scale) {
    if (!pinchZoom) return;
    
    const maxAllowedScale = (maxScale / 100) * referenceScale;
    const clampedScale = Math.min(scale, maxAllowedScale);
    const finalScale = Math.max(clampedScale, (minScale / 100) * referenceScale);
    
    // The x and y will be handled by our overridden setTransform
    pinchZoom.setTransform({
      scale: finalScale,
      allowChangeEvent: true
    });
  }

  function updateZoomDisplay() {
    const currentPercentage = Math.floor((pinchZoom.scale / referenceScale) * 100);
    currentValue.textContent = currentPercentage;
    minusButton.classList.toggle('disabled', currentPercentage <= minScale);
    minusButton.disabled = currentPercentage <= minScale;
  }

  pinchZoom.addEventListener('change', updateZoomDisplay);

  buttonsZoom.forEach(button => {
    button.addEventListener('click', function(e) {
      const currentDisplayPercentage = (pinchZoom.scale / referenceScale) * 100;
      let targetDisplayPercentage = currentDisplayPercentage + 
        (e.target.dataset.zoom === "plus" ? zoomStep : -zoomStep);
      targetDisplayPercentage = clampNumber(targetDisplayPercentage, minScale, maxScale);
      setTransform((targetDisplayPercentage / 100) * referenceScale);
    });
  });

  function setInitialZoom() {
    if (!zoomImage || zoomImage.naturalWidth <= 0 || zoomImage.naturalHeight <= 0) return;

    referenceScale = Math.min(
      window.innerWidth / zoomImage.naturalWidth,
      window.innerHeight / zoomImage.naturalHeight
    );
    
    pinchZoom.minScale = referenceScale;
    setTransform(referenceScale);
    currentValue.textContent = 100;
  }

  pinchZoom.addEventListener('wheel', (e) => {
    e.preventDefault();
    const currentDisplayPercentage = (pinchZoom.scale / referenceScale) * 100;
    let targetDisplayPercentage = currentDisplayPercentage + (e.deltaY < 0 ? zoomStep : -zoomStep);
    targetDisplayPercentage = clampNumber(targetDisplayPercentage, minScale, maxScale);
    setTransform((targetDisplayPercentage / 100) * referenceScale);
  });

  pinchZoom.addEventListener('change', () => {
    const maxAllowedScale = (maxScale / 100) * referenceScale;
    if (pinchZoom.scale > maxAllowedScale) {
      setTransform(maxAllowedScale);
    }
  });

  const observer = new MutationObserver(mutationList => {
    mutationList.forEach(mutation => {
      if (!mutation.attributeName.includes('src')) return;
      
      if (zoomImage.complete) {
        setInitialZoom();
      } else {
        zoomImage.addEventListener('load', setInitialZoom, { once: true });
      }
    });
  });
  
  observer.observe(zoomImage, { attributes: true });
  
  if (zoomImage.complete) {
    setInitialZoom();
  } else {
    zoomImage.addEventListener('load', setInitialZoom, { once: true });
  }
}

export {init};